export default function EmotionalCTA() {
  const scrollTo = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20corporate%20leadership%20scene%20with%20executive%20team%20collaborating%20in%20bright%20modern%20boardroom%2C%20warm%20ambient%20lighting%20through%20large%20windows%2C%20confident%20and%20focused%20atmosphere%2C%20soft%20cream%20tones%20with%20subtle%20warm%20accents%2C%20clean%20elegant%20aesthetic%2C%20abstract%20professional%20business%20environment%2C%20no%20text%20no%20logos%20no%20branding&width=1600&height=800&seq=leaders-emotional-cta-2026&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/75 to-black/65"></div>
          </div>

          <div className="relative z-10 p-8 md:p-16">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 leading-tight">
              Руководитель определяет потолок развития всей компании
            </h2>
            <div className="space-y-4 mb-10 max-w-3xl">
              <p className="text-base md:text-lg text-white/85 leading-relaxed">
                Можно инвестировать миллионы в рекламу, CRM и маркетинг.
              </p>
              <p className="text-base md:text-lg text-white/85 leading-relaxed">
                Но если руководители не умеют управлять людьми, делегировать, принимать решения и развивать сотрудников — рост бизнеса неизбежно остановится.
              </p>
              <p className="text-base md:text-lg text-white/85 leading-relaxed">
                Именно поэтому <strong className="text-white">обучение руководителей</strong> — одна из самых быстро окупаемых инвестиций компании.
              </p>
              <p className="text-base md:text-lg text-white/85 leading-relaxed">
                Если вы хотите вырастить сильную управленческую команду, которая самостоятельно достигает результата, — начните с диагностики текущей ситуации.
              </p>
              <p className="text-base md:text-lg text-white font-semibold leading-relaxed">
                Мы разработаем программу именно под ваши задачи, а не предложим типовой тренинг.
              </p>
            </div>

            <button
              onClick={scrollTo}
              className="bg-teal-600 text-white px-10 py-5 rounded-lg text-lg font-semibold hover:bg-teal-500 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
            >
              Получить консультацию
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}